import { Injectable } from '@angular/core';
import { Countries, Country } from '@pathe-payment/core';

export enum InfoType {
  VOUCHER = 'VOUCHER',
  CARD = 'CARD',
  GIFT_CARD = 'GIFT_CARD',
}

@Injectable()
export class InfoTypeSelectorService {
  infoTypesByCountry = new Map([
    [
      Countries.BE,
      new Map([
        [14, InfoType.CARD],
        [16, InfoType.VOUCHER],
      ]),
    ],
    [
      Countries.CH,
      new Map([
        [10, InfoType.CARD],
        [12, InfoType.VOUCHER],
        [14, InfoType.CARD],
        [16, InfoType.VOUCHER],
      ]),
    ],
    [
      Countries.FR,
      new Map([
        [12, InfoType.CARD],
        [9, InfoType.VOUCHER],
      ]),
    ],
    [
      Countries.NL,
      new Map([
        [14, InfoType.CARD],
        [16, InfoType.VOUCHER],
        [18, InfoType.GIFT_CARD],
        [19, InfoType.GIFT_CARD],
      ]),
    ],
  ]);

  getInfoType(code: string, country: Country): InfoType | null {
    return this.infoTypesByCountry.get(country)?.get(code.length) ?? null;
  }
}
